import {UncontrolledTooltip} from "reactstrap";
import {MESSAGE_CONTENT_TYPE_SYSTEM_INFO, MESSAGE_CONTENT_TYPE_SYSTEM_ERROR} from "../../../../constants";
import cx from "classnames";

const MessageDirectionSystem = ({message}) => {
    const isContentTypeSystemInfo = message.content_type === MESSAGE_CONTENT_TYPE_SYSTEM_INFO;
    const isContentTypeSystemError = message.content_type === MESSAGE_CONTENT_TYPE_SYSTEM_ERROR;

    return <div className="message" key={message.id}>
        <div className="chat-box-wrapper justify-content-center">
            <div className='message-content'>
                <div className={cx("chat-box flex-row br-a", {
                    'bg-warning-light': isContentTypeSystemInfo,
                    'bg-danger-light': isContentTypeSystemError,
                })}>
                    <div>{message.text}</div>
                    <div className='d-flex align-middle'>
                        {
                            message.step && <>
                                <i className="pe-7s-help1 pull-right ml-2"
                                style={{marginTop: '1px'}}
                                id={'message-' + message.id}
                                />

                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default MessageDirectionSystem;